import { render, staticRenderFns } from "./BlogPostSectionModule.vue?vue&type=template&id=11800706&"
import script from "./BlogPostSectionModule.vue?vue&type=script&lang=js&"
export * from "./BlogPostSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports